import { memo } from 'react';
import PlayerTimelineButton from './PlayerTimelineButton';
import { useChapterSegmentNavigation } from '../hooks/useChapterSegmentNavigation';

const PreviousChapter = () => {
  const { onClickPrev, isPrevDisabled, isFullClip } = useChapterSegmentNavigation();

  return (
    <PlayerTimelineButton
      tooltipTitle={isFullClip ? 'Previous Chapter' : 'Go to start'}
      buttonId="previous-chapter-button"
      onClick={onClickPrev}
      isDisabled={isPrevDisabled}
      iconName="IconPlayerSkipBack"
    />
  );
};

export default memo(PreviousChapter);
